export default {
  required: '此欄位必填',
  max: '最多只能選${max}個選項',
  length: '請輸入${length}個字',
  email: '請檢查E-mail格式',
  numberOnly: '只能輸入數字',
}
